import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.error("Missing Supabase env vars REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY");
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "gn_supabase_auth",
  },
});

/** Returns a friendly error message from a Supabase error object */
export function describeError(err) {
  if (!err) return "Something went wrong.";
  if (typeof err === "string") return err;
  return err.message || err.error_description || err.error || JSON.stringify(err);
}
